export default "__VITE_ASSET__1a506f38__"